import { defineMeta } from '@/registry/types';

export const checkboxMeta = defineMeta({
  name: 'Checkbox',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Boolean / multi-select control. Themed MUI Checkbox.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Checkbox',
  muiDocs: 'https://mui.com/material-ui/react-checkbox/',
  a2uiEquivalent: 'Checkbox',
  importPath: '@/atoms/Checkbox',
  optionalProps: ['checked', 'defaultChecked', 'indeterminate', 'disabled', 'size', 'onChange'],
  supportedStates: ['default', 'checked', 'indeterminate', 'disabled', 'focus'],
  designTokens: ['colors'],
  accessibility: [
    'Wrap with FormControlLabel to provide an accessible label.',
    'Keyboard: Space toggles. Group related checkboxes in a FormGroup.',
  ],
  usageExamples: ['<FormControlLabel control={<Checkbox />} label="Enable" />'],
  antiPatterns: ['Do not use a single Checkbox where a Switch (on/off setting) is more appropriate.'],
  llmSafe: true,
  whenToUse: ['Selecting multiple options', 'Opt-in / consent toggles in forms'],
  whenNotToUse: ['Mutually exclusive choices (use Radio)'],
});

export default checkboxMeta;
